/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropDown from 'app/components/common/DropDown.jsx';
import FilterItem from 'app/components/DropDownItems/FilterItem.jsx';
import GenericItem from 'app/components/DropDownItems/GenericItem.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import SearchControl from 'app/components/common/SearchControl.jsx';
import DropdownButton from 'app/components/common/DropdownButton.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import Utilities from 'app/utility/Utilities.js';

class AutomateHeader extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showRouteFilter: false,
			showRouteSort: false,
			inputContent: '',
			filterName: '',
			filterType: 0,
			sortLabel: '',
			sortOptions: [],
			inputTypes: []
		};

		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.toggleSort = this.toggleSort.bind(this);
		this.filterClick = this.filterClick.bind(this);
		this.sortRoutes = this.sortRoutes.bind(this);
		this.searchHandler = this.searchHandler.bind(this);
		this.resetSearch = this.resetSearch.bind(this);
		this.closeDropdown = this.closeDropdown.bind(this);

	}

	static getDerivedStateFromProps(nextProps, prevState) {

		let nextState = {},
		 	sortOptions = [
				{name: 'Most Recent Post', key: 'lastPost.postTs', dir: 'DESC'},
				{name: 'Active', key: 'activeFlag', dir: 'DESC'},
				{name: 'Name A-Z', key: 'name', dir: 'ASC'},
				{name: 'Name Z-A', key: 'name', dir: 'DESC'}
			],
			inputTypes = [];

		// no access to 'this' here
		if (nextProps.app.flags.routeViewType == nextProps.app.config.constants.ROUTE_VIEW_SIMPLE) {
			sortOptions = [
				{name: 'Most Recent Post', key: 'lastPost.postTs', dir: 'DESC'},
				{name: 'Active', key: 'activeFlag', dir: 'DESC'},
				{name: 'Name A-Z', key: 'inputs.0.name', dir: 'ASC'},
				{name: 'Name Z-A', key: 'inputs.0.name', dir: 'DESC'}
			];
			nextState.sortOptions = sortOptions;
		}

		if (prevState.sortOptions.length === 0) {
			nextState.sortOptions = sortOptions;
			nextState.sortLabel = 'Name A-Z';
		}

		let currentSort = nextProps.automatedRoutes.sort;

		if (currentSort) {
			for (let i = 0; i < sortOptions.length; ++i) {
				if (sortOptions[i].key.match(currentSort.key) && sortOptions[i].dir === currentSort.dir) {
					nextState = Object.assign({}, nextState, {sortLabel: sortOptions[i].name});
					break;
				}
			}
		}

		if (nextProps.automatedRoutes.types && Object.keys(nextProps.automatedRoutes.types).length > 0) {
			nextState.inputTypes = Utilities.deepClone(nextProps.automatedRoutes.types);
			if (Object.keys(nextState.inputTypes).length > 0) {
				for (let key in nextState.inputTypes) {
					if (nextState.inputTypes[key].type) {
						nextState.inputTypes[key].name = ConstantMixin.getInputServiceByCode(nextState.inputTypes[key].type);
					} else {
						nextState.inputTypes[key].name = "All";
					}
				}
			}
		}

		return nextState;

	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.app.loading.ROUTE_LIST === true && this.props.app.loading.ROUTE_LIST === false) {
			// run a default sort when the options are set
			// for simple when a route is created it'll have the same name as the feed, but if the
			// user changes the feed name the route name isn't updated and the API sorts by the route name
			this.props.sortStore('routes', this.state.sortOptions[2].key, this.state.sortOptions[2].dir);
		}

	}

	toggleDropdown(e){

		e.preventDefault();
		e.stopPropagation();

		this.setState({
			showRouteFilter: !this.state.showRouteFilter
		});

	}

	toggleSort(e) {

		e.preventDefault();
		e.stopPropagation();

		this.setState({
			showRouteSort: !this.state.showRouteSort
		});

	}

	filterClick(filterItem){
		let name = filterItem.name,
			type = filterItem.type,
			constants = this.props.app.config.constants,
			subtypes = [
				constants.INPUT_SUBTYPE_PINTEREST,
				constants.INPUT_SUBTYPE_EBAY,
				constants.INPUT_SUBTYPE_ETSY,
				constants.INPUT_SUBTYPE_MEDIUM,
				constants.INPUT_SUBTYPE_SHOPIFY,
				constants.INPUT_SUBTYPE_SQUARESPACE,
				constants.INPUT_SUBTYPE_VIMEO,
				constants.INPUT_SUBTYPE_YOUTUBE,
				constants.INPUT_SUBTYPE_SUBSTACK
			];

		if (filterItem.type === ''){
			this.props.filterStore('routes', '', '');
			name = '';
			type = 0;
		}
		else{
			// check for a subtype and modify the filter call
			if (subtypes.indexOf(parseInt(filterItem.type)) !== -1) {
				this.props.filterStore('routes', 'subtype', filterItem.type);
			} else {
				this.props.filterStore('routes', 'type', filterItem.type);
			}
		}

		this.setState({
			showRouteFilter: false,
			filterName: name,
			filterType: type
		});

		// on filter/search reset to non-detail page if any detail is open
		this.props.router.navigate("/share/automate");

	}

	sortRoutes(sort, e) {

		this.props.sortStore('routes', sort.key, sort.dir);

		this.setState({
			sortActive: false,
			sortLabel: sort.name,
			showRouteSort: false
		});
	}

	searchHandler(event, search){

		this.setState({
			inputContent: search
		});

		this.props.filterStore('routes', ['name', 'accountName', 'resource'], search);

		// on filter/search reset to non-detail page if any detail is open
		this.props.router.navigate("/share/automate");

	}

	resetSearch(e) {

		this.setState({
			inputContent: ''
		});
		this.props.filterStore('routes', ['name', 'accountName'], '');

	}

	closeDropdown(which) {

		let showRouteFilter = this.state.showRouteFilter,
			showRouteSort = this.state.showRouteSort;

		if (which === 'filter') {
			showRouteFilter = false;
		} else if (which === 'sort') {
			showRouteSort = false;
		}

		this.setState({
			showRouteFilter,
			showRouteSort
		});

	}

	render() {
		let totalRoutes = this.props.automatedRoutes.list.length,
			inputContent = this.state.inputContent,
			routeFilter = null,
			filterLabel = null,
			filterButton = null,
			filterName = '',
			totalInputs = function(routes) {
				let count = 0;
				for (let i = 0; i < routes.length; ++i) {
					if (routes[i].inputs.length) {
						count += routes[i].inputs.length;
					}
				}
				return count;
			}(this.props.automatedRoutes.list),
			sortDropdown = null,
			currentSort = this.props.automatedRoutes.sort,
			buttonLabel = 'Add New Feed',
			constants = this.props.app.config.constants;

		if (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED) {
			buttonLabel = 'Add New Route';
		}

		if (this.state.filterName != '') {
			filterName = this.state.filterName;
		}

		if (this.state.filterName === 'Feed') {
			filterName = '';
		}

		if (!totalRoutes) {
			// set up an empty button as a placeholder
			filterButton = <div className="control drop-down-button"/>;
		} else if (totalRoutes === 1) {
			filterLabel = [totalInputs, filterName, ' Input'].join(" ");
			if (this.props.app.flags.routeViewType == 1) {
				filterLabel = [totalRoutes, filterName, ' Feed'].join(" ");
			}
		} else if (this.props.automatedRoutes.filteredList.length > 0) {
			filterLabel = [this.props.automatedRoutes.filteredList.length, filterName, ' Inputs'].join(" ");
			if (this.props.app.flags.routeViewType == 1) {
				filterLabel = [this.props.automatedRoutes.filteredList.length, filterName, 'Feeds'].join(" ");
			}
		} else {
			filterLabel = ['All', totalInputs, ' Inputs'].join(" ");
			if (this.props.app.flags.routeViewType == 1) {
				filterLabel = ['All', totalRoutes, 'Feeds'].join(" ");
			}
		}

		if (this.state.showRouteFilter) {
			routeFilter = (
				<DropDown
	 				id="filter"
					items={this.state.inputTypes}
					itemElement={FilterItem}
					clickHandler={this.filterClick}
					dropDownClass="filter-dd"
					resetHandler={this.closeDropdown}/>
			);
		}

		if (this.state.showRouteSort) {
			sortDropdown = (
				<DropDown
					id="sort"
					items={this.state.sortOptions}
					itemElement={GenericItem}
					clickHandler={this.sortRoutes}
					dropDownClass="sort-dd short"
					resetHandler={this.closeDropdown} />
			);
		}

		if (filterLabel !== null) {
			filterButton = (
				<DropdownButton
					label={filterLabel}
					action={this.toggleDropdown} />
			);
		} else {
			filterButton = (
				<DropdownButton />
			);
		}

		return (
			<div>
				<Breakpoint desktop only>
					<div>
						<div className="control-bar">
							<div className="control-row">
								{filterButton}
								<div className="control search automate">
									<SearchControl
										{...this.props}
										changeHandler={this.searchHandler}
										placeholder="Search"
										resetHandler={this.resetSearch}
										wrapperClass="header-control"
										defaultFocus={false} />
								</div>

								<div className="control new automate" onClick={this.props.newRouteHandler} role="button" aria-label={buttonLabel}>
									<span className="va-helper"></span>
									<i className="fa fa-plus-square new-icon"></i> {buttonLabel}
								</div>
								<DropdownButton
									controlClass="sort solo"
									labelClass="sort"
									label={this.state.sortLabel}
									action={this.toggleSort} />
							</div>
						</div>
					</div>
				</Breakpoint>
				<Breakpoint mobile only>
					<div className="mobile-control-bar">
						<div className="control new automate" onClick={this.props.newRouteHandler} role="button" aria-label={buttonLabel}>
							<span className="va-helper"></span>
							<i className="fa fa-plus-square new-icon"></i> {buttonLabel}
						</div>
						<div className="control search automate">
							<SearchControl
								{...this.props}
								changeHandler={this.searchHandler}
								placeholder="Search"
								resetHandler={this.resetSearch}
								wrapperClass="header-control mobile"
								defaultFocus={false}
								fieldIcon="icon ion-search" />
						</div>
						<div className="control-row">
							{filterButton}
							<DropdownButton
								controlClass="sort solo"
								labelClass="sort"
								label={this.state.sortLabel}
								action={this.toggleSort} />
						</div>
					</div>
				</Breakpoint>
				{routeFilter}
				{sortDropdown}
			</div>
		);
	}

}

AutomateHeader.displayName = "AutomateHeader";

AutomateHeader.propTypes = {
	automatedRoutes: PropTypes.object,
	recordPath: PropTypes.func,
	getSavedPath: PropTypes.func,
	newRouteHandler: PropTypes.func,
};

AutomateHeader.defaultProps = {
	automatedRoutes: {
		sort: '',
        list: [],
        filter: {},
        filteredList: [],
        types: {}
	},
	recordPath: () => {},
	getSavedPath: () => {},
	newRouteHandler: () => {}
};

export default SubscriptionModule(AutomateHeader);
